import { IconTitle3 } from '@xing-com/icons';

import * as Styled from '../styles';
import type { ToolProps } from '../types';

export const HeadingH3Tool: React.FC<ToolProps> = ({ editor, disabled }) => {
  return (
    <Styled.ToolBarButton
      onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
      disabled={
        disabled ||
        !editor.can().chain().focus().toggleHeading({ level: 3 }).run()
      }
      className={editor.isActive('heading', { level: 3 }) ? 'is-active' : ''}
    >
      <IconTitle3 width={24} height={24} />
    </Styled.ToolBarButton>
  );
};
